module.exports = __webpack_public_path__ + "img/loading.99dc8744.gif";